


































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { postData, putData, NotificationData, NotificationFormData, getData } from '@/api/systemManage/notification'
import { showVaildMsg } from '@/configs/validate'
import PageForm from '@/components/pageLayout/form.vue'

// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.bubble.css'
// import 'quill/dist/quill.snow.css' // 富文本编辑器外部引用样式  三种样式三选一引入即可
// import VueQuillEditor from 'vue-quill-editor' // 调用富文本编辑器

const getFormRules = () => {
  return {
    Title: [{ required: true, message: '请输入公告标题', trigger: 'blur' }],
    Notification: [{ required: true, message: '请输入公告内容', trigger: 'blur' }],
    PublishUnit: [{ required: true, message: '请输入公告单位', trigger: 'blur' }],
  }
}

@Component({
  components: {
    PageForm
  }
})
export default class NotificationForm extends Vue {
  public expandNames: string[] = ['basic', 'position', 'status', 'pics', 'draws', 'info']
  public name = 'NotificationForm'
  public loading = false

  public form: NotificationFormData = {
    Title: '',
    Notification: '',
    PublishUnit: ''
  }
  public editorContainerCls = ""
  public editorOption = {
    modules: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['clean'],
        ['link']
      ]
    },
    placeholder: '请输入公告内容',
  }

  // #endregion
  public rules: any = getFormRules()
  // dynamic component
  public $refs!: {
    // formData: Element.Form
    formCtrl: PageForm
  }

  onEditorBlur() {
    this.editorContainerCls = ''
    this.$refs.formCtrl.validateField('Notification')
  }
  onEditorFocus() {
    this.editorContainerCls = 'editor-focused'
  }
  onEditorReady() {

  }
  public created() {
  }
  public mounted() {
    this.fetchData()
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
  public fetchData() {
    this.loading = true
    const id = +this.$router.currentRoute.params.id || 0
    this.loading = id > 0
    if (this.loading) {
      getData(id).then((response: { data: NotificationData }) => {
        this.form = response.data
        this.loading = false
      }).catch((error: any) => {
        console.log(error)
      })
    }
  }
  public onCancel() {
    this.$router.push({ path: '/Announcements' })
  }
  public onSubmit() {
    this.saveData()
    // this.$refs.elForm.validate((valid: boolean, obj: any) => {
    //   if (valid) {
    //     this.saveData()
    //   } else {
    //     showVaildMsg(this.$message, obj)
    //   }
    // })
  }

  public async saveData() {
    const id = +this.$router.currentRoute.params.id || 0
    const msg = id ? '保存' : '创建'
    try {
      const response = id ? await putData(id, this.form) :
        await postData(this.form);
      const data = response.data
      if (data && data.Id) {
        this.$router.push({ path: '/Announcements' })
        this.$message({
          message: `${msg}成功`,
          type: 'success'
        })
      }
      this.$refs.formCtrl.clearValidate()
      // if (this.$refs.elForm) {
      //   this.$refs.elForm.clearValidate()
      // }
    } catch (err) {
      console.log(err)
      this.$message({
        message: `${msg}失败,${err}`,
        type: 'warning'
      })
    }
  }
}
